import * as z from 'zod';

export const SendBiEventRequest = z.object({
  options: z
    .object({
      eventName: z
        .enum([
          'UNKNOWN',
          'APP_DASHBOARD_LOADED',
          'APP_FINISHED_CONFIGURATION',
          'APP_UPGRADED',
          'PRIMARY_ACTION_PERFORMED',
          'CUSTOM',
          'CHARGE',
          'FUNDS_RETURNED',
          'APP_FINISH_BUSINESS_SETUP',
          'APP_DEPLOYED',
          'APP_SETUP_FINISHED',
        ])
        .optional(),
      customEventName: z
        .string()
        .describe(
          'Name of your app\'s custom event that was triggered. Required when `{"eventName": "CUSTOM"}`.\n\nMin: 2 characters'
        )
        .min(2)
        .optional()
        .nullable(),
      eventData: z
        .record(z.string(), z.string())
        .describe(
          'Supported values include: `"cycle_name"`, `"currency"`, `"sum"`, `"reason"`, `"app_plan_id"`.\nYou may also submit data with keys that aren\'t listed here.\n\nAdditional data about your app\'s event.\n\n+ `"cycle_name"`: Supported values: `"monthly"`, `"yearly"`, `"2 years"`, `"one time"`.\n+ `"currency"`: 3-letter currency code in [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format.\n+ `"sum"`: Amount of money. Required for `{"eventName": "CHARGE"}` and `{"eventName": "FUNDS_RETURNED"}`.\n+ `"reason"`: Information about why the event was triggered in your app.\n+ `"app_plan_id"`: ID of the your app\'s plan as displayed in your app\'s dashboard. Note that it\'s the same value as `vendorProductId` in the [Paid Plan Purchased webhook](https://dev.wix.com/docs/rest/app-management/app-instance/paid-plan-purchased).'
        )
        .optional(),
    })
    .optional(),
});
export const SendBiEventResponse = z.object({});
